<template>
  <div>
    <panel-header>
      <span slot="text">Лунный календарь</span>
    </panel-header>

    <div class="white-wrapper text-center mt-3" v-if="isLoading">
      <spinner/>
    </div>

    <div class="white-wrapper text-center mt-3" v-if="requestError">
      <p class="default-text">Не удалось загрузить лунный календарь. Попробуйте позже.</p>
    </div>

    <template v-if="isReady">
      <moon-day-info/>
      <moon-day-widget/>
      <favorite-buttons v-if="isMobile"/>
      <moon-predictions/>
      <moon-phase-widget/>
      <horoscope-button/>
      <moon-constellation-widget/>
      <origin-button/>
    </template>
  </div>
</template>

<script>
import {isIPhone} from "@/lib/utils";
import {store} from "@/store";
import client from "@/services/client";
import config from "@/config";
import axios from "axios";
import calendar from "../../../../store/calendar.json";
import moonDaysInfo from "../../../../store/days.json";

import MoonDayWidget from "@/components/MoonDayWidget/MoonDayWidget";
import MoonPhaseWidget from "@/components/MoonPhaseWidget/MoonPhaseWidget";
import MoonConstellationWidget from "@/components/MoonConstellationWidget/MoonConstellationWidget";
import FavoriteButtons from "@/components/FavoriteButtons/FavoriteButtons";
import OriginButton from "@/components/OriginButton/OriginButton";
import MoonDayInfo from "@/components/MoonDaySummary/MoonDayInfo";
import PanelHeader from "@/components/PanelHeader/PanelHeader";
import HoroscopeButton from "@/components/HoroscopeButton/HoroscopeButton";
import MoonPredictions from "@/components/MoonPredictions/MoonPredictions";
import Spinner from "@/components/_Utlis/Spinner";

export default {
  name: "Home",
  components: {
    Spinner,
    MoonPredictions,
    MoonDayInfo,
    OriginButton,
    FavoriteButtons,
    MoonConstellationWidget,
    MoonPhaseWidget,
    MoonDayWidget,
    HoroscopeButton,
    PanelHeader,
  },
  data() {
    return {
      isLoading: false,
      requestError: null,
    }
  },
  created() {
    this.setMoonDayInfo();
  },
  methods: {
    loadMoonDayInfo() {
      let now = new Date();

      if (Object.keys(calendar).length > 0) {
        let month = calendar[now.getMonth() + 1];
        let day = month[now.getDate()];

        let moonDay = this.getMoonDay(day["moon_days"]);
        day["description_category"] = moonDaysInfo[moonDay];
        return day;
      }

      return null;
    },
    buildMoonDayInfo(day) {
      let info = {};
      let daySplitted = day["moon_days"].split(";");

      if (daySplitted.length > 1) {
        let day1 = daySplitted[0].split(" "),
            day2 = daySplitted[1].split(" ");
        info["day_name"] = day1[0] + " и " + day2[0] + " лунные сутки";
        info["day_start"] = day1[day1.length - 1];
      } else {
        let d = daySplitted[0].split(" ");
        info["day_name"] = d[0] + " лунные сутки";
        info["day_start"] = d[d.length - 1];
      }

      info["moonrise"] = day["moonrise"];
      info["moonset"] = day["moonset"];
      info["phase"] = day["phase"];
      info["quarter"] = day["quarter"];
      info["signs"] = day["signs"];

      info["description_moon_day"] = day["description_moon_day"];
      info["description_moon_in_sign"] = day["description_moon_in_sign"];
      info["description_phase_moon"] = day["description_phase_moon"];
      info["description_category"] = day["description_category"];

      info["favorability_day"] = day["favorability_day"];
      info["favorability_phase"] = day["favorability_phase"];

      return info;
    },
    setFallbackMoonDayInfo() {
      const day = this.loadMoonDayInfo();
      if (!day) {
        return false;
      }

      store.commit("setMoonDayInfo", this.buildMoonDayInfo(day));
      return true;
    },
    setMoonDayInfo() {
      if (Object.keys(store.state.moonDayInfo).length > 0) {
        return;
      }

      this.isLoading = true;
      this.requestError = null;
      const hasFallback = this.setFallbackMoonDayInfo();
      if (hasFallback) {
        this.isLoading = false;
      }

      axios.get(config["endpoint"] + "/api/moon/today", { timeout: 10000 }).then((res) => {
        store.commit("setMoonDayInfo", res["data"]["response"]);
        this.isLoading = false;
      }).catch((error) => {
        if (!hasFallback) {
          this.requestError = error;
        }
        this.isLoading = false;
        if (!hasFallback && error.message === "Network Error") {
          store.commit("setIsOffline", true);
        }
      });
    },
    getMoonDay(moonDays) {
      if (moonDays.indexOf(";") > -1) {
        return moonDays.split(";")[1].split(" ")[0]
      }
      return moonDays.split(" ")[0];
    },
    isIPhone() {
      return isIPhone(store);
    },

  },
  computed: {
    isMobile() {
      return client.isMobile();
    },
    isReady() {
      return Object.keys(store.state.moonDayInfo).length > 0 && !this.isLoading && !this.requestError;
    }
  }
}
</script>
